import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/service-request/extra-reducers';
import reducers from 'src/redux/service-request/reducers';
import { serviceRequestInitialState } from './types';

const serviceRequestSlice = createSlice({
  name: 'serviceRequest',
  initialState: serviceRequestInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  addToSrListOrReorderTheList,
  clearServiceRequestData,
  setGroupedDataMetaLoading,
  updateServiceRequestAssigneeDetails,
  updateServiceRequestsByGroupOptions,
  removeSrIdFromList,
  shouldSidePanel,
  updateServiceRequestSidePanelDetails,
  toggleToRefetchServiceRequestDetails,
  updateServiceRequestDetails,
  updateResidentInfo,
  updateSRAccessInfo,
  updateResidentAvailabilityRequestedAt,
  resolveResidentAvailabilityRequest,
  reconcileResidentAvailabilityRequest,
  updateSRWorkOrderStep,
  updateSubmittingWorkOrder,
  updateDeletingWorkOrder,
  resetSidePanelToActivityLog,
  addIssues,
  upsertWorkOrderInServiceRequest,
  removeIssue,
  updateIssueInServiceRequestWorkOrders,
  checkAndRemoveIfItemIsPresentInIssuesToAssign,
  deleteWorkOrderInServiceRequest,
  updateWorkOrderInServiceRequest,
  undoDeletedIssue,
  updateServiceRequestDetailsPropertyAddress,
  updateResidentAvailabilityDatesSr,
  updateResidentAvailability,
  clearServiceRequestUnreadMessagesCount,
} = serviceRequestSlice.actions;

export default serviceRequestSlice.reducer;
